import React, { useState, useEffect, useCallback } from "react";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { useUserContext } from "../../utils/UserContext";
import { API_URL } from "../../utils/config";
import "./detallspartidaversio.css";
import "../dashboard.css";

function DetallsPartidesPlantilla({
  mode,
  isApartat,
  plantilla,
  partida,
  codiAuto,
  partidesList,
  onNavigate,
  onSave,
  onCancel,
}) {
  const isReadOnly = mode === "consultar" || mode === "esborrar";

  TeclaEscEnter(onCancel, null);

  const { empresaSeleccionada } = useUserContext();

  // Navegació entre partides
  const currentIndex =
    partidesList && partida
      ? partidesList.findIndex((p) => parseInt(p.id) === parseInt(partida.id))
      : -1;

  const anteriorPartida = () => {
    if (!partidesList || partidesList.length <= 1 || !onNavigate) return;
    const newIdx =
      currentIndex <= 0 ? partidesList.length - 1 : currentIndex - 1;
    onNavigate(partidesList[newIdx]);
  };

  const seguentPartida = () => {
    if (!partidesList || partidesList.length <= 1 || !onNavigate) return;
    const newIdx =
      currentIndex >= partidesList.length - 1 ? 0 : currentIndex + 1;
    onNavigate(partidesList[newIdx]);
  };

  // ----------------------------------------------------------------
  //   BLOC 1: Partida, Quantitat, Unitats, Descripcio
  // ----------------------------------------------------------------
  const [codiPartida, setCodiPartida] = useState("");
  const [esApartat, setEsApartat] = useState(false);
  const [quantitat, setQuantitat] = useState("1");
  const [unitatMesura, setUnitatMesura] = useState("ut");
  const [unitatOptions, setUnitatOptions] = useState([]);
  const [descripcioPartida, setDescripcioPartida] = useState("");

  // ----------------------------------------------------------------
  //   BLOC 2: Elecció Material / Producte
  // ----------------------------------------------------------------
  const [eleccioProducte, setEleccioProducte] = useState("Material");
  const [productCatalog, setProductCatalog] = useState([]);

  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [selectedTipus, setSelectedTipus] = useState("");
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantitatProducte, setQuantitatProducte] = useState(1);

  // ----------------------------------------------------------------
  //   BLOC 3: GrupMaObra i temps
  // ----------------------------------------------------------------
  const [grupMaObraList, setGrupMaObraList] = useState([]);
  const [selectedGrupMaObra, setSelectedGrupMaObra] = useState(null);
  const [duracioEstimada, setDuracioEstimada] = useState(0);
  const [unitatsTemps, setUnitatsTemps] = useState("Hores");

  // =================================================================
  //  1) Carrega llistes
  // =================================================================
  useEffect(() => {
    const fetchProductCatalog = async () => {
      try {
        const resp = await fetch(`${API_URL}/Productes.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idEmpresa: empresaSeleccionada?.IdEmpresa || 0,
          }),
        });
        const data = await resp.json();
        if (data.success) setProductCatalog(data.productes || []);
      } catch (err) {
        console.error("Error fetchProductCatalog:", err);
      }
    };

    const fetchGrupMaObra = async () => {
      try {
        const resp = await fetch(`${API_URL}/Grupsmaobra.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idEmpresa: empresaSeleccionada?.IdEmpresa }),
        });
        const data = await resp.json();
        if (data.success) setGrupMaObraList(data.grups || []);
      } catch (err) {
        console.error("Error carregant grups ma obra:", err);
      }
    };

    const fetchUnitatsEnum = async () => {
      try {
        const resp = await fetch(`${API_URL}/Unitatsmesura.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        const data = await resp.json();
        if (data.success) {
          setUnitatOptions(data.enumValues || ["ut", "m2"]);
        }
      } catch (err) {
        console.error("Error al fetchUnitatsEnum:", err);
        setUnitatOptions(["ut", "m2"]);
      }
    };

    fetchProductCatalog();
    fetchGrupMaObra();
    fetchUnitatsEnum();
  }, [empresaSeleccionada]);

  // =================================================================
  //  2) Inicialització camps des de la partida
  // =================================================================
  useEffect(() => {
    if (partida && mode !== "nou" && mode !== "nouApartat") {
      setCodiPartida(partida.Partida || "");
      setEsApartat(parseInt(partida.EsApartat) === 1);
      setQuantitat(
        partida.Quantitat !== undefined && partida.Quantitat !== null
          ? String(partida.Quantitat)
          : "1"
      );
      setUnitatMesura(partida.Unitats || "ut");
      setDescripcioPartida(partida.DescripcioPartida || "");

      setEleccioProducte(partida.EleccioProducte || "Material");
      setSelectedMaterial(partida.Materials_idMaterials || null);
      setSelectedProduct(partida.Productes_idProductes || null);
      setQuantitatProducte(
        partida.QuantitatProd !== undefined ? partida.QuantitatProd : 1
      );

      if (partida.Productes_idProductes) {
        const prod = productCatalog.find(
          (p) => p.idProductes === parseInt(partida.Productes_idProductes)
        );
        if (prod) {
          setSelectedCategoria(prod.Categoria || "");
          setSelectedTipus(prod.Tipus || "");
          setSelectedMaterial(prod.idMaterials || null);
        }
      } else if (partida.Materials_idMaterials) {
        const mat = productCatalog.find(
          (p) => p.idMaterials === parseInt(partida.Materials_idMaterials)
        );
        if (mat) {
          setSelectedCategoria(mat.Categoria || "");
          setSelectedTipus(mat.Tipus || "");
        }
      }

      setSelectedGrupMaObra(partida.GrupMaObra_idGrupMaObra || null);
      setDuracioEstimada(partida.DuracioEstimadaUnitat || 0);
      setUnitatsTemps(partida.UnitatsTemps || "Hores");
    } else if (mode === "nou" || mode === "nouApartat") {
      setCodiPartida(codiAuto || "");
      setEsApartat(isApartat);
      setQuantitat("1");
      setUnitatMesura("ut");
      setDescripcioPartida("");
      setEleccioProducte("Material");
      setSelectedCategoria("");
      setSelectedTipus("");
      setSelectedMaterial(null);
      setSelectedProduct(null);
      setQuantitatProducte(1);
      setSelectedGrupMaObra(null);
      setDuracioEstimada(0);
      setUnitatsTemps("Hores");
    }
  }, [partida, mode, codiAuto, isApartat, productCatalog]);

  // =================================================================
  //  3) Lògica de filtrat: Categories, Tipus, Materials, Productes
  // =================================================================
  const categoriesList = Array.from(
    new Set(productCatalog.map((p) => p.Categoria).filter(Boolean))
  ).sort((a, b) => a.localeCompare(b, "ca"));

  const tipusList = Array.from(
    new Set(
      productCatalog
        .filter((p) => !selectedCategoria || p.Categoria === selectedCategoria)
        .map((p) => p.Tipus)
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b, "ca"));

  const filteredMaterials = productCatalog
    .filter((p) => !selectedCategoria || p.Categoria === selectedCategoria)
    .filter((p) => !selectedTipus || p.Tipus === selectedTipus)
    .reduce((acc, p) => {
      if (!p.idMaterials) return acc;
      const found = acc.find((x) => x.idMaterials === p.idMaterials);
      if (!found) {
        acc.push({
          idMaterials: p.idMaterials,
          NomGeneric: p.NomGeneric,
          DescripcioMaterial: p.DescripcioMaterial,
          Categoria: p.Categoria,
          Tipus: p.Tipus,
        });
      }
      return acc;
    }, [])
    .sort((a, b) => (a.NomGeneric || a.DescripcioMaterial || "").localeCompare(b.NomGeneric || b.DescripcioMaterial || "", "ca"));

  const filteredProducts = productCatalog
    .filter((p) => !selectedCategoria || p.Categoria === selectedCategoria)
    .filter((p) => !selectedTipus || p.Tipus === selectedTipus)
    .filter(
      (p) => !selectedMaterial || p.idMaterials === Number(selectedMaterial)
    )
    .sort((a, b) => `${a.Marca || ""} ${a.Model || ""}`.localeCompare(`${b.Marca || ""} ${b.Model || ""}`, "ca"));

  // =================================================================
  //  4) Handlers de selecció
  // =================================================================
  const handleChangeEleccio = (val) => {
    setEleccioProducte(val);
    setSelectedCategoria("");
    setSelectedTipus("");
    setSelectedMaterial(null);
    setSelectedProduct(null);
  };

  const onChangeMaterial = (idMaterialSeleccionat) => {
    setSelectedMaterial(idMaterialSeleccionat);
    const mat = productCatalog.find(
      (p) => p.idMaterials === idMaterialSeleccionat
    );
    if (mat) {
      setSelectedCategoria(mat.Categoria);
      setSelectedTipus(mat.Tipus);
    }
  };

  const onChangeProduct = (idProducteSeleccionat) => {
    setSelectedProduct(idProducteSeleccionat);
    const prod = productCatalog.find(
      (p) => p.idProductes === idProducteSeleccionat
    );
    if (prod) {
      setSelectedCategoria(prod.Categoria);
      setSelectedTipus(prod.Tipus);
      setSelectedMaterial(prod.idMaterials);
    }
  };

  const clearSeleccioMaterialProducte = () => {
    setSelectedCategoria("");
    setSelectedTipus("");
    setSelectedMaterial(null);
    setSelectedProduct(null);
    setQuantitatProducte(1);
  };

  // =================================================================
  //  5) SUBMIT
  // =================================================================
  const handleSubmit = async () => {
    if (!codiPartida.trim()) {
      alert("El camp Partida (codi) és obligatori!");
      return;
    }
    const qtatValid =
      quantitat === "" || quantitat === null || quantitat === undefined
        ? 0
        : parseFloat(quantitat) || 0;

    const newData = {
      Partida: codiPartida,
      EsApartat: Number(esApartat),
      Quantitat: qtatValid,
      Unitats: unitatMesura,
      DescripcioPartida: descripcioPartida || null,
      EleccioProducte: eleccioProducte,
      QuantitatProd: parseFloat(quantitatProducte || 1),
      Materials_idMaterials: selectedMaterial || null,
      Productes_idProductes: selectedProduct || null,
      GrupMaObra_idGrupMaObra: selectedGrupMaObra || null,
      DuracioEstimadaUnitat: parseFloat(duracioEstimada || 0) || null,
      UnitatsTemps: unitatsTemps,
    };

    try {
      if (mode === "nou" || mode === "nouApartat") {
        const resp = await fetch(`${API_URL}/Noupartidaplantilla.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...newData,
            idPlantilla: plantilla.id,
            idPare: partida?.id || null,
          }),
        });
        const data = await resp.json();
        if (data.success) {
          alert("Partida creada correctament!");
          onSave?.();
        } else {
          alert("Error en crear la partida: " + data.message);
        }
      } else if (mode === "modificar") {
        const resp = await fetch(`${API_URL}/Modificarpartidaplantilla.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...newData, id: partida.id }),
        });
        const data = await resp.json();
        if (data.success) {
          alert("Partida modificada correctament!");
          onSave?.();
        } else {
          alert("Error en modificar la partida: " + data.message);
        }
      } else if (mode === "esborrar") {
        if (!window.confirm("Segur que vols esborrar aquesta partida?")) return;
        const resp = await fetch(`${API_URL}/Esborrarpartidaplantilla.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: partida.id }),
        });
        const data = await resp.json();
        if (data.success) {
          alert("Partida esborrada correctament!");
          onCancel?.();
        } else {
          alert("Error en esborrar la partida: " + data.message);
        }
      }
    } catch (error) {
      console.error("Error en handleSubmit partida plantilla:", error);
      alert("S'ha produït un error en el procés.");
    }
  };

  // =================================================================
  //  6) RENDERS DE BLOCS
  // =================================================================

  const renderBloc1 = () => {
    if (isReadOnly) {
      return (
        <div className="Dashboard-info-container">
          <div>
            <strong>Partida:</strong> {codiPartida}
          </div>
          <div>
            <strong>Quantitat:</strong> {quantitat} {unitatMesura}
          </div>
          <div>
            <strong>Descripció:</strong> {descripcioPartida}
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="Dashboard-form-row">
            <label>
              Codi Partida:
              <input
                type="text"
                value={codiPartida}
                disabled
                className="camp-curt-input"
                style={{ backgroundColor: "#eee" }}
              />
            </label>
            {!esApartat && (
              <>
                <label>
                  Quantitat:
                  <input
                    type="number"
                    className="camp-curt-input"
                    step="1"
                    min="0"
                    value={quantitat}
                    onChange={(e) => setQuantitat(e.target.value)}
                  />
                </label>
                <label>
                  Unitats:
                  <select
                    value={unitatMesura}
                    onChange={(e) => setUnitatMesura(e.target.value)}
                  >
                    {unitatOptions.map((um) => (
                      <option key={um} value={um}>
                        {um}
                      </option>
                    ))}
                  </select>
                </label>
              </>
            )}
          </div>
          <div className="Dashboard-form-row">
            <label>
              Descripció Partida:
              <textarea
                rows={3}
                value={descripcioPartida}
                onChange={(e) => setDescripcioPartida(e.target.value)}
              />
            </label>
          </div>
        </>
      );
    }
  };

  const renderBloc2 = () => {
    if (esApartat) return null;

    if (isReadOnly) {
      const materialNom = partida?.NomMaterial || "";
      const producteNom = partida
        ? `${partida.MarcaProducte || ""} ${partida.ModelProducte || ""}`.trim()
        : "";

      return (
        <div className="Dashboard-info-container">
          <div>
            <strong>Elecció:</strong> {eleccioProducte}
          </div>
          {eleccioProducte === "Material" && materialNom && (
            <div>
              <strong>Material:</strong> {materialNom}
            </div>
          )}
          {eleccioProducte === "Producte" && producteNom && (
            <div>
              <strong>Producte:</strong> {producteNom}
            </div>
          )}
          <div>
            <strong>Quantitat Prod.:</strong> {quantitatProducte}
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="Dashboard-form-row">
          <label>
            Elecció Producte:
            <select
              value={eleccioProducte}
              onChange={(e) => handleChangeEleccio(e.target.value)}
            >
              <option value="Material">Material</option>
              <option value="Producte">Producte</option>
            </select>
          </label>
        </div>

        {eleccioProducte === "Material" && (
          <div className="Dashboard-form-row">
            <label>
              Categoria:
              <select
                value={selectedCategoria}
                onChange={(e) => {
                  setSelectedCategoria(e.target.value);
                  setSelectedTipus("");
                  setSelectedMaterial(null);
                }}
              >
                <option value="">-- Totes --</option>
                {categoriesList.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Tipus:
              <select
                value={selectedTipus}
                onChange={(e) => {
                  setSelectedTipus(e.target.value);
                  setSelectedMaterial(null);
                }}
              >
                <option value="">-- Tots --</option>
                {tipusList.map((tip) => (
                  <option key={tip} value={tip}>
                    {tip}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Material:
              <select
                value={selectedMaterial || ""}
                onChange={(e) =>
                  onChangeMaterial(Number(e.target.value) || null)
                }
              >
                <option value="">-- Sense selecció --</option>
                {filteredMaterials.map((mat) => (
                  <option key={mat.idMaterials} value={mat.idMaterials}>
                    {mat.NomGeneric || mat.DescripcioMaterial}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )}

        {eleccioProducte === "Producte" && (
          <div className="Dashboard-form-row">
            <label>
              Categoria:
              <select
                value={selectedCategoria}
                onChange={(e) => {
                  setSelectedCategoria(e.target.value);
                  setSelectedTipus("");
                  setSelectedMaterial(null);
                  setSelectedProduct(null);
                }}
              >
                <option value="">-- Totes --</option>
                {categoriesList.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Tipus:
              <select
                value={selectedTipus}
                onChange={(e) => {
                  setSelectedTipus(e.target.value);
                  setSelectedMaterial(null);
                  setSelectedProduct(null);
                }}
              >
                <option value="">-- Tots --</option>
                {tipusList.map((tip) => (
                  <option key={tip} value={tip}>
                    {tip}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Material:
              <select
                value={selectedMaterial || ""}
                onChange={(e) => {
                  setSelectedMaterial(e.target.value || null);
                  setSelectedProduct(null);
                }}
              >
                <option value="">-- Tots --</option>
                {filteredMaterials.map((mat) => (
                  <option key={mat.idMaterials} value={mat.idMaterials}>
                    {mat.NomGeneric}
                  </option>
                ))}
              </select>
            </label>
            <label>
              Producte:
              <select
                value={selectedProduct || ""}
                onChange={(e) =>
                  onChangeProduct(Number(e.target.value) || null)
                }
              >
                <option value="">-- Sense selecció --</option>
                {filteredProducts.map((p) => (
                  <option key={p.idProductes} value={p.idProductes}>
                    {p.Marca} {p.Model}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )}

        <div className="Dashboard-form-row">
          <label>
            Quantitat Producte:
            <input
              type="number"
              className="camp-curt-input"
              step="0.5"
              min="0"
              value={quantitatProducte}
              onChange={(e) => setQuantitatProducte(e.target.value)}
            />
          </label>

          {(selectedMaterial || selectedProduct) && (
            <button
              type="button"
              className="Dashboard-btn Dashboard-btn-cancelar"
              onClick={clearSeleccioMaterialProducte}
              title="Buidar selecció de material/producte"
            >
              Buidar
            </button>
          )}
        </div>
      </>
    );
  };

  const renderBloc3 = () => {
    if (esApartat) return null;

    if (isReadOnly) {
      const grup = grupMaObraList.find(
        (g) => g.idGrupMaObra === Number(selectedGrupMaObra)
      );
      return (
        <div className="Dashboard-info-container">
          {selectedGrupMaObra ? (
            <>
              <div>
                <strong>Grup Ma Obra:</strong>{" "}
                {grup?.Descripcio || grup?.Nom || "Sense grup"}
              </div>
              <div>
                <strong>Duració Estimada:</strong> {duracioEstimada}{" "}
                {unitatsTemps}
              </div>
            </>
          ) : (
            <div>Sense Grup de Ma d'Obra seleccionat</div>
          )}
        </div>
      );
    } else {
      return (
        <>
          <div className="Dashboard-form-row">
            <label>
              Grup Ma d'Obra:
              <select
                value={selectedGrupMaObra || ""}
                onChange={(e) => setSelectedGrupMaObra(e.target.value || null)}
              >
                <option value="">-- Sense selecció --</option>
                {grupMaObraList.map((g) => (
                  <option key={g.idGrupMaObra} value={g.idGrupMaObra}>
                    {g.Nom} ({g.PreuGrup} €/h)
                  </option>
                ))}
              </select>
            </label>

            {selectedGrupMaObra && (
              <>
                <label>
                  Duració Estimada (unitats):
                  <input
                    type="number"
                    step="0.01"
                    value={duracioEstimada}
                    onChange={(e) => setDuracioEstimada(e.target.value)}
                  />
                </label>
                <label>
                  Unitats Temps:
                  <select
                    value={unitatsTemps}
                    onChange={(e) => setUnitatsTemps(e.target.value)}
                  >
                    <option value="Minuts">Minuts</option>
                    <option value="Hores">Hores</option>
                    <option value="Dies">Dies</option>
                    <option value="Setmanes">Setmanes</option>
                    <option value="Mesos">Mesos</option>
                  </select>
                </label>
              </>
            )}
          </div>
        </>
      );
    }
  };

  const renderBotons = () => {
    const isNew = mode === "nou" || mode === "nouApartat";
    const showNav =
      partidesList &&
      partidesList.length > 1 &&
      onNavigate &&
      !isNew;

    return (
      <div
        className="Dashboard-button-group"
        style={{
          marginTop: "1rem",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        {showNav && (
          <>
            <button
              type="button"
              className="Dashboard-btn Dashboard-btn-navegar"
              onClick={anteriorPartida}
            >
              ◄ Anterior
            </button>
            <button
              type="button"
              className="Dashboard-btn Dashboard-btn-navegar"
              onClick={seguentPartida}
            >
              Següent ►
            </button>
            <span style={{ fontSize: "0.85em", color: "#666" }}>
              {currentIndex + 1} / {partidesList.length}
            </span>
          </>
        )}

        {mode !== "consultar" && mode !== "esborrar" && (
          <button
            type="button"
            className="Dashboard-btn Dashboard-btn-acceptar"
            onClick={handleSubmit}
          >
            {isNew ? "Crear" : "Modificar"}
          </button>
        )}
        {mode === "esborrar" && (
          <button
            type="button"
            className="Dashboard-btn Dashboard-btn-acceptar"
            onClick={handleSubmit}
          >
            Esborrar
          </button>
        )}
        <button
          type="button"
          className="Dashboard-btn Dashboard-btn-cancelar"
          onClick={onCancel}
        >
          {mode === "consultar" ? "Tornar" : "Cancel·lar"}
        </button>
      </div>
    );
  };

  return (
    <form className="Dashboard-form" onSubmit={(e) => e.preventDefault()}>
      {renderBloc1()}
      {renderBloc2()}
      {renderBloc3()}
      {renderBotons()}
    </form>
  );
}

export default DetallsPartidesPlantilla;
